import script from "./addAffiliate.vue?vue&type=script&setup=true&lang=js"
export * from "./addAffiliate.vue?vue&type=script&setup=true&lang=js"

import "./addAffiliate.vue?vue&type=style&index=0&id=0eb037c0&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_influencer_admin_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eb037c0"]])

export default __exports__